<div class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-gap-4 tw-rounded-2.5 tw-border tw-border-solid tw-bg-gray-100 tw-pb-7 tw-transition-colors tw-duration-200"
  role="button"
  [class.tw-border-teal-400]="selected()"
  [class.tw-border-transparent]="!selected()"
  (click)="handleSelect()">
  <div class="-tw-mt-3 tw-relative tw-h-22 tw-w-22">
    <img class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-grayscale tw-transition-opacity tw-duration-200"
      [class.tw-opacity-0]="selected()"
      [src]="plainAvatarUrl()"
      alt="" />
    <img class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-transition-opacity tw-duration-200"
      [class.tw-opacity-0]="!selected()"
      [src]="filledAvatarUrl()"
      alt="" />
  </div>
  <div class="tw-w-22 tw-text-center tw-font-lexend tw-text-600 tw-leading-1.2 tw-text-gray-800">
    <ng-content></ng-content>
  </div>
</div>
